module.exports = __webpack_public_path__ + "assets/joy.b9fd586c4b7cac645d36525a8b37dc4b.png";